function notInitialized() {
  throw new Error('SoftwareVersionService is not initialized');
}

export default {
  getVersion: notInitialized,
  upgrade: notInitialized,
};
